export const MuiFormLabel = {
  styleOverrides: {
    root: {
      left: '1px',
      fontFamily: 'Sarabun',
      fontSize: '16px',
      lineHeight: '21px',
      color: '#9F9F9F',

      '&.Mui-disabled': {
        color: 'rgba(221, 221, 234, 1)',
      },

      '&.Mui-error': {
        color: '#F44336',
      },

      '&.Mui-focused:not(.Mui-error)': {
        color: '#1EED9F',
      },

      '&.Mui-focused, &.MuiInputLabel-shrink': {
        top: '17px',
        left: '1px',
        fontSize: '12px',
        lineHeight: '12px',
      },
    },
  },
};
